/* Mobile menu: the burger opens the header as a full-screen drawer.
   =====================================================================
   header.css draws the drawer from the `gh-head-open` class on <body>, the
   contract the 1.5.x script used, so Code-injection CSS written against it
   keeps working. On top of that the drawer behaves like a modal surface:
   the burger carries aria-expanded (and aria-controls in the markup), the
   page behind the drawer is made inert so Tab and screen readers stay inside
   it, Escape closes it and returns focus to the burger, and growing the
   viewport past the drawer breakpoint closes it rather than leaving a stale
   open state behind. */

const DESKTOP_MQ = '(min-width: 901px)';

export default function initMobileMenu({ root = document } = {}) {
  const button = root.querySelector('.gh-burger');
  if (!button) return null;

  const header = button.closest('header') || root.querySelector('#gh-head');
  const isOpen = () => document.body.classList.contains('gh-head-open');

  // Everything that is not the header: computed on each toggle so a page
  // whose main/footer landmarks render later is still covered.
  const outside = () => Array.from(document.querySelectorAll('main, footer')).filter((el) => !header || !header.contains(el));

  const setOpen = (open) => {
    document.body.classList.toggle('gh-head-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    for (const el of outside()) {
      if (open) el.setAttribute('inert', '');
      else el.removeAttribute('inert');
    }
  };

  const onClick = () => setOpen(!isOpen());
  const onKeydown = (event) => {
    if (event.key !== 'Escape' || !isOpen()) return;
    setOpen(false);
    button.focus();
  };
  const mq = window.matchMedia(DESKTOP_MQ);
  const onChange = (event) => {
    if (event.matches && isOpen()) setOpen(false);
  };

  button.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeydown);
  mq.addEventListener('change', onChange);

  return () => {
    if (isOpen()) setOpen(false);
    button.removeEventListener('click', onClick);
    document.removeEventListener('keydown', onKeydown);
    mq.removeEventListener('change', onChange);
  };
}
